/**
 * Model to map task comments.
 */
export class Comment {
    id: string;
    text: string;
    writer: string;
    time: Date;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/comment.model.ts